<template>
  <div class="responsibilities-banner">
    <div class="icon-container">
      <div class="info-icon">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 13.3333V10M10 6.66667H10.0083M18.3333 10C18.3333 14.6024 14.6024 18.3333 10 18.3333C5.39763 18.3333 1.66667 14.6024 1.66667 10C1.66667 5.39763 5.39763 1.66667 10 1.66667C14.6024 1.66667 18.3333 5.39763 18.3333 10Z"
            stroke="#344054"
            stroke-width="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>

    <div class="content">
      <div class="text-container">
        <div class="title-wrap">
          <p class="title">
            You have {{ count_of_not_attached_responsibilities }} Active Responsibilities attached to nothing
          </p>
        </div>
        <p class="subtitle">
          Responsibilities attached to nothing will never be assigned
        </p>
      </div>

      <div class="actions">
        <button class="action-btn" @click="handleFilterClick">
          Filter Active Responsibilities attached to nothing
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
count_of_not_attached_responsibilities: {
    type: Number,
    default: 1
  }
})

const emit = defineEmits(['filter'])

const handleFilterClick = () => {
  emit('filter')
}
</script>

<style scoped>
.responsibilities-banner {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  border-radius: 12px;
  width: 100%;
  max-width: 1086px;
}

.icon-container {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border: 1px solid #eaecf0;
  border-radius: 8px;
  position: relative;
}

.info-icon {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 20px;
  height: 20px;
  overflow: hidden;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.text-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.title-wrap {
  display: flex;
  gap: 8px;
  padding-right: 32px;
}

.title {
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 14px !important;
  line-height: 20px;
  color: #344054;
  margin: 0;
}

.subtitle {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px !important;
  line-height: 20px;
  color: #475467;
  margin: 0;
}

.actions {
  display: flex;
  gap: 12px;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 14px !important;
  line-height: 20px;
  color: #6941c6;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.2s ease;
}

.action-btn:hover {
  opacity: 0.8;
}

.action-btn:active {
  opacity: 0.6;
}
</style>